<div role="treeitem" [@fadeIn] #parent>

    <div class="row gx-0 flex-nowrap mb-1" (click)="toggleOpen()" stop-click-bubble>        
        <div class="col-auto d-flex">
            <i *ngIf="showExpander()"
                class="expander"
                [ngClass]="
                {
                    'open-indicator': openState(),
                    'closed-indicator': !openState(),
                    'indicator-has-children': hasChildren()
                }">
            </i>
        </div>

        <div class="col">                  
                <div class="text-truncate" [ngClass]="{'fw-medium': hasChildren()}">
                    <ng-content #label select="[tree-label]" ngProjectAs="[tree-label]"></ng-content>                                   
                </div>                            
        </div>
        
    </div>


    <div #childGroup role="group" [@dropDownMenu]="openState() ? 'expanded' : 'collapsed'">        
        <ng-content ngProjectAs="[tree-child]" ></ng-content>
    </div>

</div>